import categories from './categories/routes'
import media from './media/routes'

const FighterLayout = () => import('./layouts/FighterLayout.vue')

const FighterIndex = () => import('./views/FighterIndex.vue')
const FighterCreate = () => import('./views/FighterCreate.vue')
const FighterEdit = () => import('./views/FighterEdit.vue')

export default [
  {
    path: 'fighters',
    name: 'fighters.index',
    component: FighterIndex
  },
  {
    path: 'fighters/create',
    name: 'fighters.create',
    component: FighterCreate
  },
  {
    path: 'fighters/:fighterId(\\d+)',
    component: FighterLayout,
    children: [
      {
        path: '',
        name: 'fighters.edit',
        component: FighterEdit
      },
      ...media
    ]
  },
  ...categories
]
